// import React, { useState, useEffect } from "react";
// import "./Features.css";
// import FeatureIcon1 from "../../assets/FeatureIcon1.svg";
// import { Box, Stack, Typography } from "@mui/material";
// import Button from "../../utils/Button";
// import EastIcon from "@mui/icons-material/East";
// import Awards from "./Awards";
// import pattern from "../../assets/pattern.png";
// import FeatureSide from "./FeatureSide";
// import ProductSlider from "./ProducSlider";
// import Marque from "./Marque";
// function FeaturesMain() {
//   const [activeItem, setActiveItem] = useState("item1");

//   const handleScroll = () => {
//     const sections = document.querySelectorAll(".item");
//     let active = null;
//     sections.forEach((section) => {
//       const rect = section.getBoundingClientRect();
//       if (rect.top <= 100 && rect.bottom >= 100) {
//         active = section.id;
//       }
//     });
//     setActiveItem(active);
//   };
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => {
//       setWindowWidth(window.innerWidth);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);
//   useEffect(() => {
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const handleItemClick = (item) => {
//     setActiveItem(item);
//     const element = document.getElementById(item);
//     if (element) {
//       window.removeEventListener("scroll", handleScroll); // Remove scroll event listener temporarily
//       element.scrollIntoView({ behavior: "smooth" });
//       setTimeout(() => {
//         window.addEventListener("scroll", handleScroll); // Add back the scroll event listener after a short delay
//       }, 10000); // Adjust the delay as needed
//     }
//   };

//   const lists2 = [
//     {
//       id: "1",
//       title: "GST compliance",
//       description:
//         "Our software effortlessly identifies the applicable GST components - CGST, SGST, or IGST, streamlining financial management. It automates tax compliance tasks such as generating invoices and processing e-way bills, making the process smoother for hassle-free GST management.",
//       bgcolor: "white",
//     },
//     {
//       id: "2",
//       title: "Instant E-Invoicing",
//       description:
//         "With a single click, our software empowers businesses to swiftly produce invoice reference numbers (IRNs) and QR codes. This efficient method simplifies the process of invoice generation, saving businesses from dealing with lots of steps or long procedures. Our interface enables instant creation of IRNs and QR codes.",
//       bgcolor: "#C2FFD3",
//     },

//     {
//       id: "3",
//       title: "Quick Data Access",
//       description:
//         "Access your data quickly and effortlessly with our software, ensuring easy usage across any device and location. With unmatched dependability and maximum up-time, users can consistently access their data whenever needed. Experience instant access without delays using our reliable and user-friendly software solution.",
//     },
//     {
//       id: "4",
//       title: "Inventory Tracking",
//       description:
//         "Our software helps businesses automatically update their inventory, making sure they always know exactly what they have in stock. This real-time tracking feature empowers businesses to make informed choices regarding stock control and product availability.",
//       bgcolor: "#052973",
//     },
//     {
//       id: "5",
//       title: "Easy Financial Reports",
//       description:
//         "This software effortlessly generates detailed financial reports, providing valuable insights into expenditure patterns such as income, expenses, profits and losses. It also helps you in budget planning and spending money wisely. With these reports, you can make smart decisions to improve your finances.",
//     },
//     {
//       id: "6",
//       title: "Receivable and Payables",
//       description:
//         "It simplifies the management of receivables and payables, empowering users to oversee accounts efficiently. You can quickly create professional invoices and quotes, offering diverse payment methods. Automation features ensure seamless tracking of vendor bills and expenses, while income statements and balance sheets provide accurate financial insights.",
//       bgcolor: "#F15B25",
//     },
//     {
//       id: "7",
//       title: "Currency-flexible Bills",
//       description:
//         "Sanniro offers multi-currency support, making international transactions seamless. It can generate invoices in various currencies, and also you can manage your foreign transactions in an easy way. You can apply exchange rates automatically or manually to ensure accurate billing and financial tracking.",
//     },
//     {
//       id: "8",
//       title: "Tailored Options",
//       description:
//         "You can tailor the software to fit your business perfectly with customizable templates and reports. Choose from a variety of options, including templates, fonts, and colours, to create fully personalised invoices, whether GST or non-GST. Saniiro BAIMS is completely customizable to meet your unique business requirements. ",
//     },
//   ];

//   return (
//     <Stack
//       bgcolor={"#F6F8FF"}
//       alignItems={"center"}
//       justifyContent={"center"}
//       position={"relative"}
//     >
//       <Awards />
//       {/* <Marque/> */}
//       <Stack
//         direction={{ xl: "row", xs: "column" }}
//         alignItems={"start"}
//         pt={{ xl: 70, xs: 10 }}
//         pb={{ xl: 10, xs: 0 }}
//       >
//         <Stack
//           className="sidebar"
//           alignItems={"center"}
//           position={{ xl: "sticky", xs: "relative" }}
//           p={{ xl: "116px 0" }}
//           bgcolor={"#F6F8FF"}
//           width={{ xl: "40%", xs: "100%" }}
//           pl={{ xl: 10, xs: 0 }}
//         >
//           <Stack width={"100%"}>
//             <Typography
//               fontSize={"32px"}
//               fontWeight={"bold"}
//               textTransform={"uppercase"}
//               textAlign={{ xs: "center" }}
//             >
//               What Makes
//             </Typography>
//             <Typography
//               fontSize={{ xl: "32px", sm: "30px" }}
//               fontWeight={"bold"}
//               textTransform={"uppercase"}
//               textAlign={{ xs: "center" }}
//             >
//               {/* <span style={{ fontSize: {xl:"35px",sm:"20px"} }}>Engineered to </span> */}
//               <Typography
//                 color={"#025ace"}
//                 fontWeight={"bold"}
//                 fontSize={{ xl: "75px", sm: "20px" }}
//               >
//                 Saniiro
//               </Typography>
//               So Loved?
//             </Typography>
//           </Stack>
//         </Stack>
//         <FeatureSide />
//       </Stack>
//       <ProductSlider />
//     </Stack>
//   );
// }

// export default FeaturesMain;


import React, { useState, useEffect } from "react";
import "./Features.css";
import FeatureIcon1 from "../../assets/FeatureIcon1.svg";
import { Box, Stack, Typography, Paper } from "@mui/material";
import Button from "../../utils/Button";
import EastIcon from "@mui/icons-material/East";
import Awards from "./Awards";
import pattern from "../../assets/pattern.png";
import FeatureSide from "./FeatureSide";
import ProductSlider from "./ProducSlider";
import Marque from "./Marque";
import Saniiro from "../../assets/Saniiro.png"
function FeaturesMain() {
  const [activeItem, setActiveItem] = useState("item1");

  const handleScroll = () => {
    const sections = document.querySelectorAll(".item");
    let active = null;
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= 100 && rect.bottom >= 100) {
        active = section.id;
      }
    });
    setActiveItem(active);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const saniiroFeatures = [
    {
      id: "S",
      name: "Streamlined",
      description:
        "Efficient and streamlined processes for optimal performance.",
    },
    {
      id: "A",
      name: "Accessible",
      description: "Easy access from any device, anywhere, anytime.",
    },
    {
      id: "N",
      name: "Nimble",
      description:
        "Quick and responsive to meet the dynamic needs of businesses.",
    },
    {
      id: "I",
      name: "Intuitive",
      description: "User-friendly interface that is easy to navigate.",
    },
    {
      id: "I",
      name: "Innovative",
      description: "Cutting-edge solutions that keep you ahead of the curve.",
    },
    {
      id: "R",
      name: "Reliable",
      description: "Dependable service with consistent up-time.",
    },
    {
      id: "O",
      name: "Organized",
      description:
        "Well-structured data and processes to streamline operations.",
    },
  ];

  return (
    <Stack
      bgcolor={"#F6F8FF"}
      alignItems={"center"}
      justifyContent={"center"}
      position={"relative"}
    >
      <Awards />
      {/* <Marque/> */}
      <Stack
        direction={{ xl: "row", xs: "column" }}
        alignItems={"start"}
        pt={{ xl: 70, xs: 10 }}
        pb={{ xl: 10, xs: 0 }}
      >
        <Stack
          className="sidebar"
          alignItems={"center"}
          position={{ xl: "sticky", xs: "relative" }}
          p={{ xl: "80px 0" }}
          bgcolor={"#F6F8FF"}
          width={{ xl: "40%", xs: "100%" }}
          pl={{ xl: 10, xs: 0 }}
        >
          <Stack width={"100%"}>
           
            <Typography
              fontSize={"32px"}
              fontWeight={"bold"}
              textTransform={"uppercase"}
              textAlign={{ xs: "center" }}
            >
              What Makes
            </Typography>
            <Typography
              fontSize={{ xl: "32px", sm: "30px" }}
              fontWeight={"bold"}
              textTransform={"uppercase"}
              textAlign={{ xs: "center" }}
            >
              <Typography
                color={"#025ace"}
                fontWeight={"bold"}
                fontSize={{ xl: "75px", sm: "20px" }}
              >
                Saniiro
              </Typography>
              So Loved?
            </Typography>
          </Stack>
          <Stack spacing={2}  width={"90%"} >
            <img src={Saniiro} alt="" width={"100%"} height={"100%"}/>
            {/* {saniiroFeatures.map((feature, index) => (
              <Stack direction={"row"} gap={2}>
                <Typography
                  fontSize={"35px"}
                  fontWeight="bold"
                  color={"#025ace"}
                >
                  {feature.id} -                </Typography>
                <Typography fontSize={"35px"}>{feature.name}</Typography>
              </Stack>
            ))} */}
          </Stack>
        </Stack>
        <FeatureSide />
      </Stack>
      <ProductSlider />
    </Stack>
  );
}

export default FeaturesMain;
